import React from "react";
import { useSearchPageContext } from "../SearchPageContext";
import ListingCard from "../../../composites/v2/ListingCard/ListingCard";
import { useMyCollections } from "../../../../contexts/MyCollectionsContext/MyCollectionsContext";
import { Hit, ListingCardData, mapHitToListing } from "../../../../utils/algolia/mapHitToListing";
import { hitsPerPage, primaryIndexName } from "../../../../utils/algolia/searchClient";
import useCustomSearch from "../../../../utils/algolia/useCustomSearch";
import { getLongTailPageFilters } from "../../../../utils/algolia/filters";

interface Props {
  items: Hit[];
  clickHandler: (item: Hit, listing: ListingCardData, listingCardLocation: string) => void;
}

export default function LongTailPage({ items, clickHandler }: Props) {
  const { longTailPage, myCountry, myCurrency, collectionId, remoteIp } = useSearchPageContext();
  const { allCollectionListingIds } = useMyCollections();
  const itemsToFetchCount = hitsPerPage - items.length;

  if (!longTailPage || !items.length || itemsToFetchCount < 1) return null;

  const searchQuery = {
    indexName: primaryIndexName,
    hitsPerPage: itemsToFetchCount,
    clickAnalytics: true,
    analyticsTags: ["Long Tail Page", "Custom Query"],
    filters: getLongTailPageFilters(items),
  };
  const { results, searching } = useCustomSearch([searchQuery], remoteIp);
  const newItems = results[0]?.hits || [];

  return (
    <>
      {newItems.map((item: any) => {
        const listing = mapHitToListing(item, allCollectionListingIds, myCurrency);

        return (
          <ListingCard
            key={item.id}
            listing={listing}
            handleClick={() => clickHandler(item, listing, "LongTailPage")}
            countryCode={myCountry?.code}
          />
        );
      })}
    </>
  );
}
